$(function() {
  'use strict';

  function isSafeUrl(url) {
    if (!url || typeof url !== 'string') return false;
    if (url.startsWith('/') && !url.startsWith('//')) return true;
    try {
      var parsed = new URL(url, window.location.href);
      return parsed.protocol === 'http:' || parsed.protocol === 'https:';
    } catch (e) {
      return false;
    }
  }

  $(document).on('click', 'tr[data-href]', function(event) {
    if ($(event.target).closest('a').length) return;
    const href = $(this).data('href');
    if (href && isSafeUrl(href)) window.location.href = href;
  });
});
